import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import PropTypes from 'prop-types';

import { BOTTOM_NAV_ICON_SIZE } from '../../../../BottomNav.constants';
import {
  comingSoonStyles,
  getMethodCardStyles,
  getMethodIconWrapperStyles,
  methodChipsRowStyles,
  methodTitleRowStyles,
  methodTopRowStyles,
} from '../../CreateSheet.styles';

const CHIP_VARIANT = 'BLUE';
const CHIP_SIZE = 'S';

const MethodCard = memo(
  ({
    testId,
    icon: Icon,
    iconColor,
    title,
    subtitle,
    chips = [],
    isHighlighted = false,
    isDisabled = false,
    comingSoonLabel = null,
    onPress,
  }) => {
    const cardStyles = useMemo(
      () => getMethodCardStyles({ isDisabled, isHighlighted }),
      [isDisabled, isHighlighted],
    );
    const iconWrapperStyles = useMemo(() => getMethodIconWrapperStyles(iconColor), [iconColor]);

    return (
      <Box
        component="button"
        data-testid={testId}
        disabled={isDisabled}
        sx={cardStyles}
        onClick={onPress}
      >
        <Box sx={methodTopRowStyles}>
          <Box sx={iconWrapperStyles}>
            <Icon size={BOTTOM_NAV_ICON_SIZE} />
          </Box>
          <Box sx={methodTitleRowStyles}>
            <Typography color="text.primary" variant="medium16">
              {title}
            </Typography>
            {comingSoonLabel ? (
              <Typography color="text.secondary" sx={comingSoonStyles} variant="regular12">
                {comingSoonLabel}
              </Typography>
            ) : null}
          </Box>
        </Box>
        <Typography color="text.secondary" variant="regular12">
          {subtitle}
        </Typography>
        {chips.length > 0 ? (
          <Box sx={methodChipsRowStyles}>
            {chips.map(chip => (
              <LabelCDS key={chip} size={CHIP_SIZE} title={chip} variant={CHIP_VARIANT} />
            ))}
          </Box>
        ) : null}
      </Box>
    );
  },
);

MethodCard.propTypes = {
  testId: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  chips: PropTypes.arrayOf(PropTypes.string),
  isHighlighted: PropTypes.bool,
  isDisabled: PropTypes.bool,
  comingSoonLabel: PropTypes.string,
  onPress: PropTypes.func,
};

export default MethodCard;
